import theme from "@theme/index";

const tableToolbarStyles = {
  alignItems: {
    sm: "center",
    xs: "flex-start",
  },
  backgroundColor: theme.palette.grey[200],
  border: `1px solid ${theme.palette.grey[300]}`,
  color: theme.palette.text.primary,
  display: "flex",
  flexDirection: {
    sm: "row",
    xs: "column",
  },
  height: 106,
  justifyContent: "space-between",
  px: 4,
  py: 4,
};

export default tableToolbarStyles;
